// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_hour").html(cutDownTimeText.hour);
    $(".sp_minute").html(cutDownTimeText.minute);
    $(".sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  let imgArr = [
    'https://cdn.shopify.com/s/files/1/0767/6503/6846/files/20250901-p1.png',
    'https://cdn.shopify.com/s/files/1/0767/6503/6846/files/20250901-p1-1.png',
  ]
  preloadImages(imgArr)

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    // 第一个Swiper - CPL Anti-Glare
    const swiper1 = new Swiper(".sp-swiper1", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
      on: {
        slideChange: function () {
          // 获取对应的sp-content
          const spContent = document.querySelector('.sp-part4 .sp-content:not([style*="top"])');
          if (spContent) {
            // 移除所有active类
            const items = spContent.querySelectorAll('div');
            items.forEach(item => item.classList.remove('active'));
            // 给当前索引的项添加active类
            const currentIndex = this.realIndex;
            if (items[currentIndex]) {
              items[currentIndex].classList.add('active');
            }
          }
        }
      }
    });

    // 第二个Swiper - 8-Point Star Effect
    const swiper2 = new Swiper(".sp-swiper2", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
      on: {
        slideChange: function () {
          // 获取对应的sp-content（有top样式的）
          const spContent = document.querySelector('.sp-part4 .sp-content[style*="top"]');
          if (spContent) {
            // 移除所有active类
            const items = spContent.querySelectorAll('div');
            items.forEach(item => item.classList.remove('active'));
            // 给当前索引的项添加active类
            const currentIndex = this.realIndex;
            if (items[currentIndex]) {
              items[currentIndex].classList.add('active');
            }
          }
        }
      }
    });

    new Swiper(".sp-swiper3", {
      autoplay: {
        disableOnInteraction: false,
        delay: 2500,
      },
      spaceBetween: 0,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".sp-pagination",
        clickable: true,
      },
    });


    // 为sp-content中的按钮添加点击事件
    // 第一个sp-content的按钮点击事件
    const firstSpContent = document.querySelector('.sp-part4 .sp-content:not([style*="top"])');
    if (firstSpContent) {
      const buttons = firstSpContent.querySelectorAll('div');
      buttons.forEach((button, index) => {
        button.addEventListener('click', function() {
          // 移除所有active类
          buttons.forEach(btn => btn.classList.remove('active'));
          // 添加active类到当前按钮
          this.classList.add('active');
          // 切换到对应的slide
          swiper1.slideTo(index);
        });
      });
    }

    // 第二个sp-content的按钮点击事件
    const secondSpContent = document.querySelector('.sp-part4 .sp-content[style*="top"]');
    if (secondSpContent) {
      const buttons = secondSpContent.querySelectorAll('div');
      buttons.forEach((button, index) => {
        button.addEventListener('click', function() {
          // 移除所有active类
          buttons.forEach(btn => btn.classList.remove('active'));
          // 添加active类到当前按钮
          this.classList.add('active');
          // 切换到对应的slide
          swiper2.slideTo(index);
        });
      });
    }

    // 只针对产品选择区域的sp-option
    const productOptions = document.querySelector('.product-part .op-group');
    if (productOptions) {
      const options = productOptions.querySelectorAll('.sp-option');
      options.forEach((option, index) => {
        option.addEventListener('click', function() {
          // 移除所有active类
          options.forEach(btn => btn.classList.remove('active'));
          // 切换产品图片
          document.querySelector('.product-part .sp-img1').setAttribute('src', imgArr[index]);
          // 给当前点击的选项添加active类
          this.classList.add('active');
          
          // 隐藏所有sp-round中的图片
          const allImages = productOptions.querySelectorAll('.sp-round img');
          allImages.forEach(img => {
            img.style.display = 'none';
          });
          
          // 显示当前选中选项的图片
          const currentImage = this.querySelector('.sp-round img');
          if (currentImage) {
            currentImage.style.display = 'block';
          }
        });
      });
    }

    $('.sp-btn-style').click(function () {
      const id = $(this).siblings('.op-group').find('.sp-option.active').data('id');
      window.location.href = '/cart/' + id + ':' + 1
    })

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 340 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



  // 标题文本渐出
  // const graduallyList = document.getElementsByClassName("gradually");
  // for (let gradually of graduallyList) {
  //   const spans = gradually.querySelectorAll("span");
  //   const paragraph = gradually.querySelector(".sp-detail");

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           // 给每个 span 和 i 动画
  //           spans.forEach((span, index) => {
  //             span.style.animation = `swift-up-fade 0.5s ease forwards`;
  //             span.style.animationDelay = `${index * 0.1}s`;

  //             const i = span.querySelector("i");
  //             if (i) {
  //               i.style.animation = `swift-up-fade 0.5s ease forwards`;
  //               i.style.animationDelay = `${index * 0.1}s`;
  //             }
  //           });

  //           // 段落
  //           const totalDelay = spans.length * 0.1 + 0.3;
  //           if (paragraph) {
  //             paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
  //             paragraph.style.animationDelay = `${totalDelay}s`;
  //           }

  //           observer.unobserve(gradually);
  //         }
  //       });
  //     },
  //     {
  //       threshold: 0.3,
  //     }
  //   );
  //   observer.observe(gradually);
  // }



  // 环形旋转木马
  // var slideW = 360; //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
  // var radius = (slideW * 0.5) / Math.sin(Math.PI / 16); //半径。圆心并不是视点中心，视点在1200px
  var slideW = 340; //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16
  var radius = (slideW * 0.5) / Math.sin(Math.PI / 12); //半径。圆心并不是视点中心，视点在1200px

  carouselSwiper = new Swiper("#carousel .swiper", {
    watchSlidesProgress: true,
    slidesPerView: "auto",
    centeredSlides: false,
    loop: true,
    loopedSlides: 3,
    grabCursor: true,
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    freeMode: true,
    speed: 5000, //匀速时间
    on: {
      progress: function (swiper, progress) {
        for (i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i);
          var slideProgress = this.slides[i].progress;
          const translateX =
            (slideProgress + 1) *
              (slideW / 4 -
                (Math.cos((slideProgress + 1) * (1 / 6) * Math.PI) *
                  slideW *
                  1.2) /
                  4) +
            "px"; //调整图片间距，根据图片宽度改变数值实现自适应
          const rotateY = (slideProgress + 1) * 30; //图片角度
          const translateZ =
            radius -
            Math.cos((slideProgress + 1) * (1 / 6) * Math.PI) * radius -
            150 +
            "px"; //调整图片远近，刚好4个在画框内
          slide.transform(
            "translateX(" +
              translateX +
              ") translateZ(" +
              translateZ +
              ") rotateY(" +
              rotateY +
              "deg)"
          );
        }
      },
      setTransition: function (swiper, transition) {
        for (var i = 0; i < this.slides.length; i++) {
          var slide = this.slides.eq(i);
          slide.transition(transition);
        }
      },
    },
  });
  


}

mainRender();